import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { TODO } from '@b2c/types/index';
import angular, { IHttpService } from 'angular';
import { FormResponsesServiceModule } from './responses/responses.service';
import { ACMEResponse } from '@b2c/types/core';

export class FormsService {
  static $inject = ['$http', 'ApiVersionFactory', 'FormResponsesService'];

  api = {
    countries: (props: { tenantId: string }) => {
      return this.$http<ACMEResponse<TODO>>({
        method: 'get',
        url: `/v2/b2c/locations/avs/countries`,
        headers: {
          'x-b2c-tenant-id': props.tenantId,
        },
      });
    },

    states: (props: { tenantId: string; country: string }) => {
      return this.$http<ACMEResponse<TODO>>({
        method: 'get',
        url: `/v2/b2c/locations/states/${props.country}`,
        headers: {
          'x-b2c-tenant-id': props.tenantId,
        },
      });
    },

    detail: (props: { tenantId: string; id: string }) => {
      return this.$http<ACMEResponse<TODO>>({
        method: 'get',
        url: `/v2/b2c/forms/${props.id}`,
        headers: {
          'x-b2c-tenant-id': props.tenantId,
        },
      });
    },
  };

  responses = this.FormResponsesService;

  model: TODO[] = [];

  constructor(private $http: IHttpService, private ApiVersionFactory: TODO, private FormResponsesService: TODO) {}

  init() {
    return true;
  }

  setForms(forms) {
    this.model = forms;
  }

  getForms(onlyIds) {
    let r = this.model;

    if (onlyIds) {
      r = this.getIds();
    }

    return r;
  }

  getCartForms() {
    const result: TODO[] = [];
    const responses = this.responses.getResponses();

    for (let i = 0, ii = responses.length; i < ii; i++) {
      result.push({ formResponseId: responses[i].id });
    }

    return result;
  }

  getIds() {
    const result: TODO[] = [];

    for (let i = 0, ii = this.model.length; i < ii; i++) {
      result.push(this.model[i].id);
    }

    return result;
  }

  addForm(form) {
    const found = this.findForm(form);
    let r;

    if (!found) {
      this.model.push(form);
      r = form;
    } else {
      r = found.form;
    }

    return r;
  }

  hasForms() {
    return this.model instanceof Array && this.model.length;
  }

  findForm(props) {
    let result: TODO | false = false;

    if (props) {
      for (let i = 0; i < this.model.length; i++) {
        if (
          this.model[i].id === props.id &&
          this.model[i].formResponseId === props.formResponseId &&
          this.model[i].itemId === props.itemId &&
          this.model[i].itemName === props.itemName &&
          this.model[i].itemType === props.itemType &&
          this.model[i].pricePointId === props.pricePointId &&
          this.model[i].pricePointName === props.pricePointName &&
          this.model[i].pricePointName === props.oncePerCart
        ) {
          result = {
            index: i,
            form: this.model[i],
          };
          break;
        }
      }
    }

    return result;
  }

  findFormById(id) {
    let result: TODO | false = false;

    if (id) {
      for (let i = 0; i < this.model.length; i++) {
        if (this.model[i].id === id) {
          result = {
            index: i,
            form: this.model[i],
          };
          break;
        }
      }
    }

    return result;
  }
}

export const FormsServiceModule = angular
  .module('acme.common.service.forms', [ApiVersionFactoryModule, FormResponsesServiceModule])
  .service('FormsService', FormsService).name;
